import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import axios from "axios";
import moment from "moment";
import "./CheckinCheckout.css";
import { UserConsumer } from "../../UserContext";
import { CheckInCheckOutAPIs } from "./CheckInCheckOutAPIs";
import { dateCol, timeCol } from "../ticketModule/variables/ListingVariables";
import ExtractEmpDetails from "./ExtractEmpDetails";
import CheckInOutDetails from "./CheckInOutDetails";
import { AlertPopups } from "../../components/AlertPopups";
import Header from "../../components/Header";
import { Redirect, useParams, useLocation } from "react-router-dom";
import homeIcon from "../../images/icons/homeIcon.png";
import officeIcon from "../../images/icons/officeIcon.png";
import { Image } from "react-bootstrap";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../components/GlobalPaginationSize";
import { APIDateFormat } from "../Dashboard/DashboardVariables";

const CheckInCheckOut = () => {
	let token,
		empID,
		empLoggedInId,
		empDesignation = null;
	const params = useParams();
	const location = useLocation();
	let WorkStationId = params.id;
	let SpDashboarCheckinCheckoutEmp = new URLSearchParams(location.search).get(
		"Emp"
	);
	let SpDashboarMonthlyEmp = new URLSearchParams(location.search).get(
		"Employee"
	);
	let redirectedStatus = location?.state?.redirectedState;
	let redirectedEmp = SpDashboarCheckinCheckoutEmp || SpDashboarMonthlyEmp;

	let lateComingLateSittingCMRedirection =
		location?.state?.lateComingLateSitting;
	let lateComingLateSittingCMDate = lateComingLateSittingCMRedirection
		? location.state?.date
		: null;

	let date = new Date();
	const [startDate, setStartDate] = useState(
		WorkStationId
			? new Date(date.getFullYear(), date.getMonth(), 1)
			: SpDashboarCheckinCheckoutEmp
			? new Date()
			: lateComingLateSittingCMRedirection
			? moment(lateComingLateSittingCMDate + new Date().getFullYear())._d
			: SpDashboarMonthlyEmp
			? moment(date).startOf("month")._d
			: moment(date).subtract(28, "days")._d
	);
	const [endDate, setEndDate] = useState(
		lateComingLateSittingCMRedirection
			? moment(lateComingLateSittingCMDate + new Date().getFullYear())._d
			: new Date()
	);
	const [supEmpList, setSupEmpList] = useState([{}]);
	const [statusType, setStatusType] = useState([]);
	const [employeeId, setEmployeeId] = useState();
	const [selectedEmployee, setSelectedEmployee] = useState(null);
	const [status, setStatus] = useState(
		redirectedStatus ||
			lateComingLateSittingCMRedirection || { value: 0, label: "All" }
	);
	const [employeeRecord, setEmployeeRecord] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [flag, setFlag] = useState(false);
	const [totalHours, setTotalHours] = useState(null);
	const [pageNum, setPageNum] = useState(1);
	const [isBtnLoading, setIsBtnLoading] = useState(false);

	const workStationList = [
		{ value: 0, label: "All" },
		{ value: 1, label: "Work From Home" },
		{ value: 2, label: "Work From Office" },
		{ value: 3, label: "Continuing Work From Office" },
	];
	const [selectedWorkStation, setSelectedWorkStation] = useState({
		value: 0,
		label: "All",
	});
	const columns = [
		{
			dataField: "recordDate",
			text: "Date",
			sort: true,
			formatter: dateCol,
		},
		{ dataField: "recordDay", text: "Day", sort: false },
		{ dataField: "employee", text: "Employee", sort: true },
		{
			dataField: "checkedInAt",
			text: "Checkin Time",
			sort: true,
			formatter: (cell, row) => {
				const { checkedInAt, checkedInFromOffice } = row;
				return checkedInAt ? (
					checkedInFromOffice != null ? (
						checkedInFromOffice ? (
							<>
								{moment(checkedInAt).format("HH:mm")}
								<Image
									src={officeIcon}
									className="officeIcon"
									alt="office"
									title="Checkin from Office"
								/>
							</>
						) : (
							<>
								{moment(checkedInAt).format("HH:mm")}
								<Image
									src={homeIcon}
									className="homeIcon"
									alt="home"
									title="Checkin from Home"
								/>
							</>
						)
					) : (
						moment(checkedInAt).format("HH:mm")
					)
				) : (
					"N/A"
				);
			},
		},
		{
			dataField: "checkedOutAt",
			text: "Checkout Time",
			sort: true,
			formatter: (cell, row) => {
				const { checkedOutAt, checkedOutFromOffice } = row;
				return checkedOutAt ? (
					checkedOutFromOffice != null ? (
						checkedOutFromOffice ? (
							<>
								{moment(checkedOutAt).format("HH:mm")}
								<Image
									src={officeIcon}
									className="officeIcon"
									alt="office"
									title="Checkout from Office"
								/>
							</>
						) : (
							<>
								{moment(checkedOutAt).format("HH:mm")}
								<Image
									src={homeIcon}
									className="homeIcon"
									alt="home"
									title="Checkout from Home"
								/>
							</>
						)
					) : (
						moment(checkedOutAt).format("HH:mm")
					)
				) : (
					"N/A"
				);
			},
		},
		{
			dataField: "workDuration",
			text: "Hours Worked",
			sort: true,
			formatter: timeCol,
		},
		{
			dataField: "workStation",
			text: "Work Station",
			sort: true,
		},
		{
			dataField: "status",
			text: "Status",
			sort: true,
			style: (status) => {
				return status === "CheckOut Missing"
					? { color: "red" }
					: status === "Checkout Missing"
					? { color: "red" }
					: status === "Present"
					? { color: "rgb(67, 163, 165)" }
					: status === "Late Coming"
					? { color: "red" }
					: { color: "rgb(67, 163, 165)" };
			},
		},
	];
	const defaultSorted = [
		{
			dataField: "recordDate",
			order: "desc",
		},
	];
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [pagerData, setPagerData] = useState(null);
	const [formData, setFormData] = useState({
		empName: "",
		status: "",
		startDate: "",
		endDate: "",
	});
	useEffect(() => {
		if (WorkStationId) {
			setFormData({
				...formData,
				startDate: new Date(date.getFullYear(), date.getMonth(), 1),
				status: 0,
			});
			setStartDate(new Date(date.getFullYear(), date.getMonth(), 1));
		} else if (SpDashboarCheckinCheckoutEmp) {
			setFormData({
				...formData,
				startDate: new Date(),
				status: 0,
			});
			setStartDate(new Date());
		} else if (lateComingLateSittingCMDate) {
			setFormData({
				...formData,
				startDate: moment(
					lateComingLateSittingCMDate + new Date().getFullYear()
				)._d,
				status: 0,
			});
			setStartDate(
				moment(lateComingLateSittingCMDate + new Date().getFullYear())
					._d
			);
		} else if (SpDashboarMonthlyEmp) {
			setFormData({
				...formData,
				startDate: moment(date).startOf("month")._d,
				status: 0,
			});
			setStartDate(moment(date).startOf("month")._d);
		} else {
			setFormData({
				...formData,
				startDate: moment(date).subtract(28, "days")._d,
				status: 0,
			});
			setStartDate(moment(date).subtract(28, "days")._d);
		}

		getSupEmpList();
		getStatus();
	}, []);

	const handleChange = (e) => {
		const value = e.value;
		setFormData({ ...formData, [e.target.name]: value });
	};
	const getSupEmpList = () => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		if (
			empLoggedInId.toString() === "4" ||
			empID.toString() === "180" ||
			empID.toString() === "66" ||
			empID.toString() === "33" ||
			empID.toString()==="471"

		) {
			//CM
			axios
				.get(`${CheckInCheckOutAPIs.GetSupEmpListForCM}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					let empData = data.map((data) => {
						return { value: data.employeeId, label: data.name };
					});
					empData = empData.sort((a, b) =>
						a.label.localeCompare(b.label)
					);
					empData.unshift({ value: -1, label: "All" });
					setSupEmpList(empData);
					if (WorkStationId) {
						let id = parseInt(WorkStationId);
						let emp = empData.find((emp) => emp.value === id);
						if (emp) {
							if (redirectedEmp) {
								emp = empData.find(
									(emp) =>
										emp.value ===
										SpDashboarCheckinCheckoutEmp
								);
								setSelectedEmployee(emp);
								setEmployeeId(SpDashboarCheckinCheckoutEmp);
							} else {
								setSelectedEmployee(emp);
								setEmployeeId(emp.value);
							}
							callExtractCheckInCheckOutAPI(null, pageSize);
						}
					} else {
						if (
							empLoggedInId.toString() === "4" ||
							empID.toString() === "180" ||
							empID.toString() === "66" ||
							empID.toString() === "33" ||
							empID.toString() === "471"
						) {
							//jibran,ABZ, Sufian & Asif
							if (redirectedEmp) {
								let emp = empData.find(
									(emp) =>
										emp.value === parseInt(redirectedEmp)
								);
								setSelectedEmployee(emp);
								setEmployeeId(redirectedEmp);
								callExtractCheckInCheckOutAPI(
									redirectedEmp,
									pageSize
								);
							} 
						} else callExtractCheckInCheckOutAPI(null, pageSize);
					}
				});
		} else {
			axios
				.get(`${CheckInCheckOutAPIs.GetSupEmpList}?isActive=true`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					let empData = data.employees.map((data) => {
						return {
							value: data.employeeId,
							label: data.employeeName,
						};
					});
					empData = empData.sort((a, b) =>
						a.label.localeCompare(b.label)
					);
					empData.unshift({ value: -1, label: "All" });
					setSupEmpList(empData);
					if (WorkStationId) {
						let id = parseInt(WorkStationId);
						let emp = empData.find((emp) => emp.value === id);
						if (emp) {
							if (redirectedEmp) {
								emp = empData.find(
									(emp) =>
										emp.value ===
										SpDashboarCheckinCheckoutEmp
								);
								setSelectedEmployee(emp);
								setEmployeeId(SpDashboarCheckinCheckoutEmp);
							} else {
								setSelectedEmployee(emp);
								setEmployeeId(emp.value);
							}
							callExtractCheckInCheckOutAPI(null, pageSize);
						}
					} else {
						if (
							empLoggedInId.toString() === "4" ||
							empID.toString() === "180" ||
							empID.toString() === "66" ||
							empID.toString() === "33" ||
							empID.toString() === "471"
						) {
							//jibran,ABZ, Sufian & Asif
							if (redirectedEmp) {
								let emp = empData.find(
									(emp) =>
										emp.value === parseInt(redirectedEmp)
								);
								setSelectedEmployee(emp);
								setEmployeeId(redirectedEmp);
								callExtractCheckInCheckOutAPI(
									redirectedEmp,
									pageSize
								);
							} else {
								setSelectedEmployee({
									value: -1,
									label: "All",
								});
								setEmployeeId(-1);
								callExtractCheckInCheckOutAPI(-1, pageSize);
							}
							setEmployeeId(-1);
							callExtractCheckInCheckOutAPI(-1, pageSize);
						} else if (redirectedEmp) {
							let emp = empData.find(
								(emp) => emp.value === parseInt(redirectedEmp)
							);
							setSelectedEmployee(emp);
							setEmployeeId(redirectedEmp);
							callExtractCheckInCheckOutAPI(
								redirectedEmp,
								pageSize
							);
						}
					}
				});
		}
	};

	const getStatus = () => {
		axios
			.get(`${CheckInCheckOutAPIs.GetCheckInCheckOutStatus}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				let statusList = data.statuses.filter(
					(item) => item.label != "All"
				);
				let sorted = statusList.sort((a, b) =>
					a.label.localeCompare(b.label)
				);
				sorted.unshift({ value: 0, label: "All" });
				setStatusType(sorted);
			});
	};

	const startDateHandleChange = (date) => {
		setStartDate(date);
	};
	const endDateHandleChange = (date) => {
		setEndDate(date);
	};

	const getEmpID = (obj) => {
		setSelectedEmployee(obj);
		setEmployeeId(obj.value);
	};
	const getEmpstatus = (obj) => {
		setStatus(obj);
	};

	const callExtractCheckInCheckOutAPI = (defaultId, pageSize) => {
		setIsLoading(true);

		axios
			.get(
				`${CheckInCheckOutAPIs.GetCheckInCheckOutRecord}/${
					employeeId || defaultId || WorkStationId
				}?StartDate=${moment(startDate).format(
					APIDateFormat
				)}&EndDate=${moment(endDate).format(APIDateFormat)}&Status=${
					typeof status === "object" ? status.value : status
				}&PageNumber=1&PageSize=${
					pageSize || numberOfItemsPerPage
				}&WorkStation=${selectedWorkStation.value}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((res) => {
			
				setFlag(true);
				setTotalHours(res.data.totalHours);
				setEmployeeRecord(res.data["extractCheckinCheckout"]);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
				setPageNum(1);
				setIsLoading(false);
			})
			.catch((err) => {
				if (err.response?.data) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				} else if (!status) {
					AlertPopups.ErrorAlert.fire({
						text: "Please Select Status",
					});
				} else if (!startDate) {
					AlertPopups.ErrorAlert.fire({
						text: "Please Enter Start Date",
					});
				} else if (!endDate) {
					AlertPopups.ErrorAlert.fire({
						text: "Please Enter End Date",
					});
				}
			});
	};
	const getExtractCheckInCheckOutRecord = () => {
		employeeId
			? callExtractCheckInCheckOutAPI()
			: AlertPopups.ErrorAlert.fire({
					text: "Please Select Employee First",
			  });
	};

	const exportToExcel = () => {
		setIsBtnLoading(true);
		employeeId
			? axios({
					url: `${
						CheckInCheckOutAPIs.ExportToExcel
					}/${employeeId}/ExportToExcel?Status=${
						typeof status === "object" ? status.value : status
					}&StartDate=${moment(startDate).format(
						APIDateFormat
					)}&WorkStation=${
						selectedWorkStation.value
					}&EndDate=${moment(endDate).format(APIDateFormat)}`,
					method: "GET",
					responseType: "blob",
					headers: {
						Authorization: `Bearer ${token}`,
					},
			  })
					.then((response) => {
						const url = window.URL.createObjectURL(
							new Blob([response.data])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"EmployeeCheckinCheckout.xlsx"
						);
						document.body.appendChild(link);
						link.click();
						setIsBtnLoading(false);
					})
					.catch((error) => {
						if (error.response) {
							AlertPopups.ErrorAlert.fire({
								text: `${error.response.data.message}`,
							});
						}
						setIsBtnLoading(false);
					})
			: AlertPopups.ErrorAlert.fire({
					text: "Please Select Employee",
			  });
	};

	const receiveData = (PageSize) => {
		setIsLoading(true);
		axios
			.get(
				`${
					CheckInCheckOutAPIs.GetCheckInCheckOutRecord
				}/${employeeId}?PageSize=${PageSize}&PageNumber=1&Status=${
					typeof status === "object" ? status.value : status
				}&WorkStation=${selectedWorkStation.value}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}&StartDate=${moment(startDate).format(
					APIDateFormat
				)}&EndDate=${moment(endDate).format(APIDateFormat)}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setFlag(true);
					setTotalHours(res.data.totalHours);
					setPageNum(1);
					setIsLoading(false);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setEmployeeRecord(res.data.extractCheckinCheckout);
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			apiURL = `${
				CheckInCheckOutAPIs.GetCheckInCheckOutRecord
			}/${employeeId}?StartDate=${moment(startDate).format(
				APIDateFormat
			)}&EndDate=${moment(endDate).format(
				APIDateFormat
			)}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${
				typeof status === "object" ? status.value : status
			}&WorkStation=${
				selectedWorkStation.value
			}&SortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${
				CheckInCheckOutAPIs.GetCheckInCheckOutRecord
			}/${employeeId}?StartDate=${moment(startDate).format(
				APIDateFormat
			)}&EndDate=${moment(endDate).format(
				APIDateFormat
			)}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${
				typeof status === "object" ? status.value : status
			}&WorkStation=${
				selectedWorkStation.value
			}&SortBy=${sortField}_${sortOrder}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						setFlag(true);
						setTotalHours(res.data.totalHours);
						setPageNum(page);
						setIsLoading(false);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setEmployeeRecord(res.data.extractCheckinCheckout);
					}
				});
		}
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				debugger
				token = userDetails.token;
				empID = userDetails.id;
				empLoggedInId = userDetails.designation;
				empDesignation = userDetails.designation;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.id==="471" ||
					userDetails.empRole.includes("3") ? (
					<Container fluid className="pr-3 pl-3">
						<Header
							title="Extract Checkin Checkout"
							headerBorder={true}
						/>

						<ExtractEmpDetails
							startDateHandleChange={startDateHandleChange}
							endDateHandleChange={endDateHandleChange}
							workStationList={workStationList}
							selectedWorkStation={selectedWorkStation}
							handleWorkStationChange={(obj) => {
								setSelectedWorkStation(obj);
							}}
							startDate={startDate}
							endDate={endDate}
							options={supEmpList}
							selectedStatus={status}
							status={statusType}
							handleChange={handleChange}
							formData={formData}
							getEmpID={getEmpID}
							getEmpstatus={getEmpstatus}
							selectedEmployee={selectedEmployee}
							getExtractCheckInCheckOutRecord={
								getExtractCheckInCheckOutRecord
							}
							exportToExcel={exportToExcel}
							showBtnLoading={isBtnLoading}
							employeeRecord={employeeRecord}
						/>
						<div className="excluded-hours mt-0">
							*Lunch hours are excluded
						</div>
						<CheckInOutDetails
							employeeRecord={employeeRecord}
							receiveData={receiveData}
							isLoading={isLoading}
							paginationPage={pageNum}
							columns={columns}
							defaultSorted={defaultSorted}
							pagerData={pagerData}
							pageNum={pageNum}
							numberOfItemsPerPage={numberOfItemsPerPage}
							sortBy={sortBy}
							handleTableChange={handleTableChange}
							flag={flag}
							flagTitle={"Average Score"}
							flagCount={totalHours}
						/>
					</Container>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default CheckInCheckOut;
